/**
 * Resumen de proteccion de datos que acompana a la casilla de autorizacion.
 *
 * Es texto legal: vive en su propio fichero para que se pueda revisar y
 * cambiar sin tocar la logica del modal. Adaptado del formulario general de
 * Service Club, con una diferencia importante: aqui solo se piden nombre y
 * correo, asi que las categorias de datos dicen eso y no la lista larga.
 */

/** Enlace a la politica de privacidad. */
export const PRIVACY_POLICY_URL = 'https://serviceclub.com/us/privacy/';

/** Texto de la casilla. Es el consentimiento en si: se guarda con el premio. */
export const CONSENT_LABEL =
  'I authorise Service Club ® to process my personal data to handle my request.';

export function DataProtectionNotice() {
  return (
    <details className="dp-notice">
      <summary>Data protection summary</summary>
      <ul>
        <li>
          <strong>Controller:</strong> Service Club Acquisition and Development of Labor Talent
          S.L. (Av. Diagonal 601, Planta 8, 08028 Barcelona, Spain).
        </li>
        <li>
          <strong>Purpose:</strong> Hand out the prize you have just won and send communications
          about our products by email.
        </li>
        <li>
          <strong>Source:</strong> You, the data subject.
        </li>
        <li>
          <strong>Data categories:</strong> Identification and contact details (name and email).
        </li>
        <li>
          <strong>Your rights:</strong> Access, rectification, deletion, restriction, portability,
          and objection.
        </li>
        <li>
          <strong>More info:</strong>{' '}
          <a href={PRIVACY_POLICY_URL} target="_blank" rel="noreferrer noopener">
            Privacy policy
          </a>
          .
        </li>
      </ul>
    </details>
  );
}
